import {
  GET_POPULAR_BETS_REQUEST,
  GET_POPULAR_BETS_SUCCESS,
  GET_POPULAR_BETS_FAILURE,
  POPULAR_BETS_WS_EVENT_REMOVE,
  POPULAR_BETS_WS_ODD_UPDATE,
  POPULAR_BETS_WS_ODD_REMOVE
} from 'Store/constants';

const initialState = {
  data: [],
  isLoading: null,
  error: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    
    case GET_POPULAR_BETS_REQUEST:
      return { ...state, data: [], isLoading: true, error: null };

    case GET_POPULAR_BETS_SUCCESS:
      return { ...state, data: action.payload, isLoading: false, error: null };

    case GET_POPULAR_BETS_FAILURE:
      return { ...state, isLoading: false, error: action.payload };

    case POPULAR_BETS_WS_EVENT_REMOVE:
      return {
        ...state,
        data: action.data,
      };

    case POPULAR_BETS_WS_ODD_UPDATE:
      return {
        ...state,
        data: action.data,
      };

    case POPULAR_BETS_WS_ODD_REMOVE:
      return {
        ...state,
        data: action.data,
      };
  

    default:
      return state;
  }
};
